import React from "react";
import TextInfo from "./TextInfo";

const Actor = ({ actor, fundLocal = null }) => {
  return (
    <div>
      <TextInfo
        className=""
        title=""
        text={actor?.firstname + " " + actor?.lastname}
      />
      {actor?.email != null &&
        actor?.email != undefined &&
        actor?.email != "" && (
          <div className="flex flex-row gap-2">
            <svg
              className="mx-3 lucide lucide-mail-icon lucide-mail"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect width="20" height="16" x="2" y="4" rx="2" />
              <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
            </svg>
            <TextInfo className="" title="" text={"  " + actor?.email} />
          </div>
        )}
      {actor?.society != null &&
        actor?.society != undefined &&
        actor?.society != "" && (
          <div className="flex flex-row gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="mx-3 lucide lucide-globe-icon lucide-globe"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
              <path d="M2 12h20" />
            </svg>
            <TextInfo
              className=""
              title=""
              text={
                "  " +
                (actor?.society == fundLocal?.name
                  ? fundLocal?.uri
                  : actor?.society)
              }
            />
          </div>
        )}
      {actor?.phone != null &&
        actor?.phone != undefined &&
        actor?.phone != "" && (
          <div className="flex flex-row gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className=" mx-3 lucide lucide-phone-icon lucide-phone"
            >
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
            <TextInfo className="" title="" text={"  " + actor?.phone} />
          </div>
        )}
    </div>
  );
};

export default Actor;
